module.exports = __webpack_public_path__ + "img/photo-14.50178b49.jpg";